import { render, staticRenderFns } from "./AppBudgetItemDialog.vue?vue&type=template&id=6a6a5a62&scoped=true&"
import script from "./AppBudgetItemDialog.vue?vue&type=script&lang=js&"
export * from "./AppBudgetItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppBudgetItemDialog.vue?vue&type=style&index=0&id=6a6a5a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a5a62",
  null
  
)

export default component.exports